import Phaser from 'phaser';
import { Colors } from '../../consts/Colors';
import { tags } from '../../consts/Tags';

export default class Zone1 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, zoneData) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneId = zoneData.zoneId
        this.zoneData = zoneData

        this.isDone = false;

        this.dropZone = this.scene.add.image(0, 0, this.zoneData.image).setOrigin(0.5);
        this.add(this.dropZone);
        
        this.setSize(this.dropZone.width, this.dropZone.height);
    }

    setActive() {
        this.dropZone.setTexture(this.zoneData.image);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    addDeck(deck) {
        this.deck = deck;
    }

    setFalse() {
        this.dropZone.setTexture(this.zoneData.image + "_false");
        this.disableInteractive();
    }

    setDone() {
        this.isDone = true;
        this.disableInteractive();
        this.dropZone.setVisible(false);
    }

    reset(){
        if(!this.isDone) {
            this.setActive()
        }
    }

    onPointerOver() {
        if(!this.isDone) {
            this.dropZone.setTexture(this.zoneData.image + "_over");
        }
    }
    onPointerOut() {
        if(!this.isDone) {
            this.dropZone.setTexture(this.zoneData.image);
        }
    }
    dragOnPointerOver() {
        if(!this.isDone) {
            this.dropZone.setTexture(this.zoneData.image + "_over");
        }
    }
    dragOnPointerOut() {
        if(!this.isDone) {
            this.dropZone.setTexture(this.zoneData.image);
        }
    }

    

    
}